<div class="list validation" ng-click="toggleOptions()" ng-class="{'not-selected': !selectedOption}">
    <label class="selected" ng-class="{'has-value':selectedOption.value!=''}"><i ng-if="selectedOption.valid === false" class="fa fa-exclamation-triangle"></i><span ng-bind-html="selectedOptionText()"></span> <i class="fa fa-angle-right"></i></label>
    <div class="option-list" ng-if="showOptions">
        <input class="selectOptionsFilterInput" ng-if="options.length > 6" style="margin: 3px 10px 3px 13px" type="text" ng-click="vm.overrideClick($event)"
           ng-model="vm.filterText" ng-keydown="vm.keydownHandler($event)" placeholder="{{'filterWaterMark.search' | translate}}"/>
        <ul>
            <li ng-if="selectedTitle" class="option-title"><span>{{selectedTitle}}</span><hr></li>
            <li ng-repeat="option in options | filter:vm.filterText" ng-click="select(option); $event.stopPropagation();" class="option">
                <span ng-class="{'bold':option.value==selectedOption.value}">
                    <i ng-if="option.valid === false" class="fa fa-exclamation-triangle"></i>
                    <span ng-bind-html="option.text|cHighlight:vm.highlight"></span>
                    <span ng-if="option.additionalinfo && option.additionalinfo.length" class="lightgrey"><br />{{option.additionalinfo}}</span>
                </span>
            </li>
        </ul>
    </div>
</div>
<div ng-messages="vm.validation.$error" class="error-text">
    <div ng-message="required">{{'field.validation.required' | translate}}</div>
</div>

